/**
 * Created by zhengyf on 2018.1.22.
 */

/**
 * normalEditorComponent 组件
 * setting：
 *      {hiddenAddCustomNavButton, hiddenUserSelector, onlyListDefaultNavTpl}
 */

;(function () {

    NormalEditorCtrl.$inject = ['TinyEditorService', 'handleTmplService', '$timeout', '$scope', '$http', '$interval', 'render', 'event'];
    handleTmplService.$inject = ['request'];
    angular
        .module('DSSXAPP')
        .component('normalEditorComponent', {
            template:'<div class="product-post-component product-post-component-custom-editor"><div id="custom-editor" class="clearfix"><div class="left-content"><div id="tny-nav" class="left-nav"><a href="/tmpl-edit.html?from=nav" ng-if="!vm.c.setting.hiddenAddCustomNavButton" target="_blank">添加自定义导航</a> <i ng-click="vm.d.showNavigationTemplate = !vm.d.showNavigationTemplate"></i></div><textarea maxlength="19999"></textarea><div render style="display: none;"></div></div><div class="right-content" ng-show="vm.d.showNavigationTemplate"><div id="custom-title-ops" class="custom-ops"><div class="ops-head"><div>导航模板</div><select id="mceHeadUserTrigger" ng-if="!vm.c.setting.hiddenUserSelector" class="mce-select"><option value="cn1520798608wnuz">David Chow</option><option value="cn1519886015wybr">Amy Lau</option><option value="cn1519878601afwc">Amber Lau</option><option value="cn1519864304ttpw">Yukie Lau</option></select></div><div class="ops-body"><div id="hard-itme-c" ng-class="{\'no-border\': vm.c.setting.onlyListDefaultNavTpl}" class="hard-itme-c"><div class="nav-tmpl-item" ng-repeat="item in hardNavTmpls" ng-click="vm.f.addTmpl(item)"><div class="title" ng-bind="item.title"></div></div></div><div id="self-item-c" ng-if="!vm.c.setting.onlyListDefaultNavTpl" class="self-item-c"><div class="nav-tmpl-item" ng-click="vm.f.addTmpl(item)" ng-repeat="item in myNavTmpls"><div class="title" ng-bind="item.title"></div><div class="tip" ng-bind="item.tip" ng-show="item.tip"></div></div></div></div><div class="ops-bottom"><a href="/tmpl-mgr.html" ng-if="!vm.c.setting.hiddenAddCustomNavButton" class="hl" target="_blank">管理模板</a></div></div></div></div><upload-local-pic show="vm.d.showLocalUploadPic" pic-count="vm.d.picCount"></upload-local-pic><upload-bank-pic show="vm.d.showBankUploadPic" pic-count="vm.d.picCount"></upload-bank-pic></div>',
            bindings: {
                setting: '<', // 组件配置
                content: '<', // 普通编辑内容
                getEditContent: '=', // 获得普通编辑内容
                onContentChange: '&' // 普通编辑内容发生变化触发的函数
            },
            controllerAs: 'vm',
            controller: NormalEditorCtrl
        })
        .service("render", ['$compile', function ($compile) {
            var thiz = this;
            this.group = null;
            this.renderHtml = function (html, scope) {
                if (!html) {
                    layer.msg("添加失败", {icon: 2});
                    return false;
                }
                var e = angular.element(html);
                thiz.group.append(e);
                $compile(e)(scope);
                return true;
            };
            this.getRes = function () {
                var res = thiz.group.html();
                thiz.group.empty();
                return res;
            }
        }])
        .service('handleTmplService', handleTmplService)
        .directive("render", ['render', function (render) {
            return function (sc, ele) {
                render.group = ele;
            }
        }])
        .filter('to_trusted', ['$sce', function ($sce) {
            return function (text) {
                return $sce.trustAsHtml(text);
            };
        }]);

    function handleTmplService(request) {
        var thiz = this;
        var myNavTmpls = [];

        var hardNavTmpls = [
            {title: "Product Description"},
            {title: "Packaging & Shipping"},
            {title: "Our Services"},
            {title: "Company Information"},
            {title: "FAQ"}
        ];
        this.triggerRefresh = function (closeWin) {
            localStorage.dirty = "true";
            if (closeWin) {
                window.close();
            }
        };
        this.autoRefresh = function () {
            localStorage.dirty = "";
            setInterval(function () {
                if (localStorage.dirty) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 100);
                }
            }, 200);
        };
        var getCalled = false;
        this.get = function (callback) {
            if (getCalled) {
                if (callback) {
                    callback(hardNavTmpls, myNavTmpls);
                }
                return;
            }

            request.post('/usr/api/opNavTmpl', {method: 'get'}, {}, true)
                .then(function (res) {
                    getCalled = true;
                    _get(callback, res.data);
                }, function (error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'handleTmplService',
                        funcName: 'get',
                        text: 'handleTmplService fail'
                    });
                });
        };

        this.sync = function (reload, close) {
            if (myNavTmpls.length > 20) {
                layer.confirm("导航模板数已经到达上限 20，请清理后重新添加", {
                    scrollbar: false,
                    closeBtn: 0,
                    shade: [0.9, '#393D49'],
                    btn: ["我知道了"]
                });
                return;
            }

            var temp = {
                fixedNavTmpl: hardNavTmpls,
                variedNavTmpl: myNavTmpls
            };
            request.post('/usr/api/opNavTmpl', {method: 'update'}, temp, true)
                .then(function (res) {
                    layer.msg("提交成功", {icon: 1});
                    if (reload) {
                        thiz.triggerRefresh(close);
                    }
                    if (close) {
                        setTimeout(function () {
                            window.close();
                        }, 700);
                    }
                }, function (error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'handleTmplService',
                        funcName: 'sync',
                        text: 'handleTmplService fail'
                    });
                })
        };
        this.del = function (index) {
            if (index >= myNavTmpls.length) {
                console.error("myNavTmpls del index out of bounds");
                return;
            }
            myNavTmpls.splice(index, 1);
            thiz.sync(true, false);
        };
        this.add = function (obj) {
            myNavTmpls.push(obj);
            return true;
        };

        function _get(callback, data) {

            hardNavTmpls = (data.fixedNavTmpl && data.fixedNavTmpl.length) ? data.fixedNavTmpl : hardNavTmpls;
            myNavTmpls = (data.variedNavTmpl && data.variedNavTmpl.length) ? data.variedNavTmpl : myNavTmpls;
            if (callback) {
                callback(hardNavTmpls, myNavTmpls);
            }
        }

        thiz.get();
    }

    function NormalEditorCtrl(TinyEditorService, handleTmplService, $timeout, $scope, $http, $interval, render, event) {
        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this,
            instanceId,
            store = {
                mQuery: tinymce.dom.DomQuery,
                tmpl: null,
                editor: null
            }
        ;

        vm.d = {
            showNavigationTemplate: true, // 控制是否显示编辑器右边的导航模板部分
            showLocalUploadPic: false, // 是否显示本地上传图片的组件
            showBankUploadPic: false, // 是否显示图片银行上传图片的组件
            picCount: 15, // 剩余可以上传的图片张数
        };

        vm.c = {
            setting: {
                hiddenAddCustomNavButton: false, // 隐藏 添加自定义导航 按钮，同时也会隐藏 管理模板 按钮
                hiddenUserSelector: false, // 隐藏 用户 选择菜单
                onlyListDefaultNavTpl: false, // 仅列出默认的导航模板，不列出用户自定义的
            },
        };

        vm.f = {
            addTmpl: addTmpl
        };

        function onInit() {
            console.log('[NormalEditorCtrl init: ]');
            initCustomEditor();
            initInterval();
            getTmpl();
            initVM();
            watchEditorContent();
        }

        function bindingsOnChanges(changes) {

            if (changes.setting) {
                setSetting(vm.setting);
            }

            if (changes.content) {
                updateContent(vm.content);
            }
        }

        // 设置 config
        function setSetting(setting) {
            vm.c.setting = angular.extend({}, vm.c.setting, setting);
        }

        function initCustomEditor() {

            var options = {
                selector: '#custom-editor textarea',
                setup: function (editor) {
                    addImg = function (imgAddr) {
                        editor.insertContent('<img style="max-width: 750px" src="' + imgAddr + '">');
                    };
                    editor.addButton('upload', {
                        title: "从我的电脑选择图片",
                        image: "/images/custom-editor/pic-icon.png",
                        onclick: function () {
                            var numberOfRemainingPictures = TinyEditorService.getPicCount(instanceId);
                            if (numberOfRemainingPictures <= 0) {
                                layer.msg("图片上传数量已到达上限");
                                return;
                            }
                            vm.d.showLocalUploadPic = true
                            vm.d.picCount = numberOfRemainingPictures
                        }
                    });
                    editor.addButton('upload4bank', {
                        title: "从图片银行选择图片",
                        image: "/images/custom-editor/bank-pic.png",
                        onclick: function () {
                            var numberOfRemainingPictures = TinyEditorService.getPicCount(instanceId);
                            if (numberOfRemainingPictures <= 0) {
                                layer.msg("图片上传数量已到达上限");
                                return;
                            }
                            vm.d.showBankUploadPic = true
                            vm.d.picCount = numberOfRemainingPictures
                        }
                    });
                    var c = tinymce.ui.Factory.create({
                        type: 'menuitem',
                        text: '插入链接',
                        onclick: function () {
                            var l = prompt("请输入链接", "");
                            if (!l || l.length <= 0) {
                                return;
                            }
                            if (l.indexOf("http") !== 0) {
                                l = "http://" + l;
                            }
                            var jNode = $(editor.selection.getNode());
                            if (jNode.parent()[0].nodeName === "A") {
                                (jNode.parent().attr("href", l))
                            } else {
                                jNode.wrap('<a href="' + l + '" target="_blank"></a>');
                            }
                        }
                    });
                    editor.addMenuItem('myMenuItem2', c);
                }
            }

            TinyEditorService.createInstance(options, null, 50000).then(function (res) {
                instanceId = res.id;
                store.editor = res.editor;
                TinyEditorService.setContent(instanceId, vm.content || '');
                bindEditorEvents();
            });
        }

        function updateContent(content) {
            if (!instanceId) {
                return;
            }
            TinyEditorService.setContent(instanceId, content);
        }

        function initVM() {
            vm.getEditContent = getEditContent;
        }

        function getTmpl() {
            $http.get("/tmpl/navTmpl.html").then(function (data) {
                store.tmpl = data.data;
            });

            handleTmplService.get(function (hardNavTmpls, myNavTmpls) {
                $scope.myNavTmpls = myNavTmpls;
                $scope.hardNavTmpls = hardNavTmpls;
            });
        }

        function initInterval() {
            $interval(function () {
                var obj;
                try {
                    obj = angular.fromJson(localStorage.addTmplItemData)
                } catch (e) {
                    return;
                }
                if (!angular.isObject(obj)) {
                    return;
                }
                addTmpl(obj.tmpl);
                if (obj.save) {
                    $scope.myNavTmpls.push(obj.tmpl);
                }
                localStorage.addTmplItemData = '';
            }, 200);
        }

        function addTmpl(item) {
            //判断重复
            var curTitles = store.mQuery(store.editor.getBody()).find(".tmpl-title");
            for (var i = 0; i < curTitles.length; i++) {
                if (curTitles[i].innerText === item.title) {
                    layer.alert('您已插入一个名为“' + item.title + '”的导航，请勿重复使用。', {title: "提示"});
                    return;
                }
            }

            var newScope = $scope.$new();
            newScope.item = item;
            if (!render.renderHtml(store.tmpl, newScope)) {
                return;
            }

            $timeout(function () {
                var nodeToAdd = tinymce.DOM.create("p", {}, render.getRes());
                var insertAfter = store.editor.selection.getNode();
                var p = store.mQuery(insertAfter).parent()[0];
                if (p.nodeName === "HTML") {  //没有焦点时点击添加
                    var pArr = store.mQuery(insertAfter).find("p");
                    var lastP = pArr[pArr.length - 1];
                    if (lastP) {
                        store.mQuery(lastP).before(nodeToAdd);
                    } else {
                        store.editor.getBody().append(nodeToAdd)
                    }

                } else {  // 找到上层父节点
                    while (p.nodeName !== "BODY") {
                        insertAfter = p;
                        p = store.mQuery(insertAfter).parent()[0];
                    }
                    store.mQuery(insertAfter).after(nodeToAdd);
                }
                bindOneNodeEvent(nodeToAdd);
                TinyEditorService.reCount(instanceId);
            }, 100);
        }

        // 从我的电脑添加图片成功回调
        DSSX.customEditorUploaderPichandler = {
            onSuccess: function (imgs) {
                var _imgs = imgs || [];
                var count = TinyEditorService.getPicCount(instanceId);

                if (_imgs.length > count) {
                    _imgs = _imgs.slice(0, count);
                }

                for (var i = 0; i < _imgs.length; i++) {
                    addImg(_imgs[i]);
                }
            }
        };

        // 获取普通编辑内容
        function getEditContent() {
            return {
                text: TinyEditorService.getContent(instanceId),
                remainWordCount: TinyEditorService.getWordCount(instanceId),
                remainImgCount: TinyEditorService.getPicCount(instanceId)
            };
        }

        // 为富文本绑定事件
        function bindEditorEvents() {
            store.editor.on('setcontent beforeaddundo keyup', function () {
                vm.onContentChange({
                    $event: {
                        content: {
                            text: TinyEditorService.getContent(instanceId),
                            remainWordCount: TinyEditorService.getWordCount(instanceId),
                            remainImgCount: TinyEditorService.getPicCount(instanceId)
                        }
                    }
                });
            });
            store.editor.on("contextMenu", function (event) {
                if (store.editor.selection.getNode().nodeName !== "IMG") {
                    return false;
                }
            });
            bindAllTmplEvent();
        }

        function bindAllTmplEvent() {
            store.editor.on('dragstart', function (event) {
                if (event.target.nodeName !== 'IMG') {
                    event.preventDefault();
                }
            });
            var ts = store.mQuery(store.editor.getBody()).find('.nav-tmpl-c');
            for (var i = 0; i < ts.length; i++) {
                bindOneNodeEvent(ts[i]);
            }
        }

        function bindOneNodeEvent(nodeToAdd) {
            var title = store.mQuery(nodeToAdd).find(".title-wrap")[0];
            var content = store.mQuery(nodeToAdd).find(".tmpl-content")[0];
            var close = store.mQuery(nodeToAdd).find(".close")[0];
            store.editor.selection.setCursorLocation(content, 0);
            tinymce.DOM.unbind(title, "click");
            tinymce.DOM.bind(title, "click", function () {
                //设置不能点击标题，转移焦点
                store.editor.selection.setCursorLocation(content, 0);
            });

            var n = nodeToAdd;
            var id = setInterval(function () {
                var shouldDel = store.mQuery(n).find(".title-wrap").length === 0
                    || store.mQuery(n).find(".title-wrap")[0].innerHTML.length === 0
                    || store.mQuery(n).find(".tmpl-content").length === 0;
                if (shouldDel) {
                    n.remove();
                    clearInterval(id);
                }
            }, 200);

            tinymce.DOM.unbind(close, "click");
            tinymce.DOM.bind(close, "click", function () {
                clearInterval(id);
                n.remove();
            });
            tinymce.DOM.bind(nodeToAdd, "change", function () {
                layer.msg("change");
            });
        }

        // 编辑器回填内容以后，绑定自定义导航事件
        function watchEditorContent() {
            event.on('getEditorContent', function () {
                $timeout(function () {
                    if (store.editor && store.mQuery(store.editor.getBody()).find('.nav-tmpl-c').length) {
                        var ts = store.mQuery(store.editor.getBody()).find('.nav-tmpl-c');
                        for (var i = 0; i < ts.length; i++) {
                            bindOneNodeEvent(ts[i]);
                        }
                    }
                })
            });
        }
    }

})();
